import * as React from "react";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { DeleteOutlined } from "@ant-design/icons";
import { DropdownChildButton } from "src/components/buttons/DropdownChildButton";
import { msgQueueStore } from "src/components/MsgQueue";
import { TableStore } from "src/components/tables/TableStore";
import {
  hasPermissionIn,
  Permission,
  WithPermissions,
} from "src/types/Permission";
import { ModalDelete } from "src/components/ModalDelete";
import { onError } from "src/common/onError";
import { rest, stdParamsSerializer } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { EntityFilters, ZEntityRow } from "./types";

type PropsEntityMassDeleteButton = {
  tableStore: TableStore<ZEntityRow, EntityFilters>;
};

export const EntityMassDeleteButton: React.FC<PropsEntityMassDeleteButton> =
  observer((props) => {
    const { tableStore } = props;
    const { selected } = tableStore;
    let reason: string = "";
    const stateIds = new Set(selected.map(({ stateId }) => stateId));
    if (stateIds.size === 0) {
      reason = "Ничего не выбрано";
    } else if (stateIds.size > 1) {
      reason = "Выбранные экземпляры в разных состояниях";
    } else {
      const noDel = (selected as WithPermissions[]).find(
        (it) => !hasPermissionIn(it, Permission.entityDelete),
      );
      if (noDel) reason = "Нет прав на удаление экземпляров";
    }
    const count = selected.length;

    const [open, setOpen] = React.useState(false);
    const [waiting, setWaiting] = React.useState(false);
    const onDelete = async () => {
      setWaiting(true);
      try {
        await rest.delete(apiObjUrl("/entities"), {
          params: {
            ids: selected.map(({ id }) => id),
          },
          paramsSerializer: stdParamsSerializer,
        });
        setOpen(false);
        msgQueueStore.add({
          type: "success",
          message: t("N items deleted", { count }),
        });
        tableStore.setSelected([]);
        tableStore.load({ page: 0 });
      } finally {
        setWaiting(false);
      }
    };

    return (
      <>
        <DropdownChildButton
          icon={<DeleteOutlined />}
          disabled={!!reason}
          danger
          onClick={() => setOpen(true)}
          title={reason}
        >
          Массовое удаление
        </DropdownChildButton>
        <ModalDelete
          open={open}
          onCancel={() => setOpen(false)}
          onOk={() => {
            onDelete().catch(onError);
          }}
          message={t("Confirm deletion of N instances", { count })}
          waiting={waiting}
        />
      </>
    );
  });
